export default "__VITE_ASSET__10c452b6__"